import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { Pagination } from '@src/api/types/pagination';
import { IndexRequest } from '@src/api/types/shared/request';

export type TenantUser = {
  id: number;
  email: string;
  created_on: string;
  family_name: string;
  first_name: string;
  role_name: string;
  status: boolean;
  authenticated: boolean;
};

export type TenantUserIndexResponse = {
  data: TenantUser[];
  pagination: Pagination;
};

type TenantUserCreateRequest = {
  tenant_user: {
    family_name: string;
    first_name: string;
    family_name_kana: string;
    first_name_kana: string;
    email: string;
    role_id: string;
  };
};

export type TenantUserCreateResponse = unknown;

export type TenantUserCreateErrorResponse = {
  tenant_user: {
    family_name: string[];
    first_name: string[];
    family_name_kana: string[];
    first_name_kana: string[];
    email: string[];
    role_id: string[];
  };
};

export type TenantUserShowResponse = {
  id: number;
  role_id: string;
  family_name: string;
  first_name: string;
  family_name_kana: string;
  first_name_kana: string;
  email: string;
  expires_at: string;
  enabled: boolean;
  can_resend_invitation: boolean;
};

export type TenantUserUpdateRequest = {
  tenant_user: {
    role_id: string;
    family_name: string;
    first_name: string;
    family_name_kana: string;
    first_name_kana: string;
    expires_at: string | undefined;
    enabled?: boolean;
  };
};

export type TenantUserUpdateResponse = unknown;

export type TenantUserUpdateErrorResponse = {
  tenant_user: {
    family_name: string[];
    first_name: string[];
    family_name_kana: string[];
    first_name_kana: string[];
    role_id: string[];
    enabled: string[];
  };
};

export type SuggestEmailRequest = {
  family_name: string;
  first_name: string;
  suggested_email: string;
};

export type SuggestEmailResponse = unknown;

export type SuggestEmailErrorResponse = {
  suggested_email: string[];
};

export const tenantUserApiClient = {
  index: async (params: IndexRequest = {}): Promise<ApiResult<TenantUserIndexResponse>> => {
    return await axiosClient.get('/tenant/tenant-users', { params });
  },
  create: async (
    params: TenantUserCreateRequest,
  ): Promise<ApiResult<TenantUserCreateResponse, TenantUserCreateErrorResponse>> => {
    return await axiosClient.post('/tenant/tenant-users', params);
  },
  show: async (id: number): Promise<ApiResult<TenantUserShowResponse>> => {
    return await axiosClient.get(`/tenant/tenant-users/${id}`);
  },
  update: async (
    id: number,
    data: TenantUserUpdateRequest,
  ): Promise<ApiResult<TenantUserUpdateResponse, TenantUserUpdateErrorResponse>> => {
    return await axiosClient.put(`/tenant/tenant-users/${id}`, data);
  },
  sendSuggestion: async (
    id: number,
    data: SuggestEmailRequest,
  ): Promise<ApiResult<SuggestEmailResponse, SuggestEmailErrorResponse>> => {
    return await axiosClient.put(`/tenant/tenant-users/${id}/email/suggestion`, data);
  },
};
